<template>
  <div class="full">
    <div v-if="listLength">
      <div class="voteBox" v-for="(item, index) in currentData" :key="index" @click="getInfo(item)">
        <div class="time">
          距离投票结束还剩:
          <span>
            <van-count-down :time="time" format="DD 天 HH 时 mm 分" />
          </span>
        </div>
        <div class="voteName" @click="getInfo(item)">
          <img src="../../assets/img/ico_toupiao.png" alt="" />
          <div class="name">{{ item.tpmc }}</div>
        </div>

        <div class="voteBottom">
          <div class="voteIn">
            <img src="../../assets/img/ico_renshu.png" alt="" />
            <span>参与:{{ item.tprs }}人</span>
          </div>

          <div class="VoteType">{{ item.tplx | title }}</div>
          <button v-if="item.tpzt == 0" disabled>
            {{ item.tpzt | btn }}
          </button>
          <button v-else-if="item.tpzt == 1" disabled>
            {{ item.tpzt | btn }}
          </button>

          <van-button v-else disabled color="#BABABA">
            {{ item.tpzt | btn }}
          </van-button>
        </div>
      </div>
    </div>
    <div v-if="vLoading" style="width: 100% height: 100px; text-align: center; margin-top: 40px">
      <van-loading size="30px">加载中...</van-loading>
    </div>
    <div class="content" v-if="!vLoading && !currentData.length">
      <div class="top">
        <img class="image" src="../../assets/img/img_toupiao_nodata.png" alt="" />
      </div>
      <div class="footer">
        <p class="nodata">暂无数据</p>
      </div>
    </div>
  </div>
</template>

<script>
import noData from "../components/noData.vue"
import api from '@/api/vote.js'
export default {
  components: { noData },
  props: {
    active: {
      typeof: String,
      default: ""
    },
    // wyqyId: Number,
    params: Object
  },
  data() {
    return {
      time: 30 * 60 * 60 * 1000,
      currentData: [],
      vLoading: true,
      wyqyId: 0
    };
  },
  filters: {
    title(val) {
      if (val == 0 || val == 1) {
        return "使用投票"
      } else {
        return "验收投票"
      }
    },
    btn(val) {
      if (val == 0) {
        return "使用投票"
      } else if (val == 1) {
        return "已投票"
      } else {
        return '已结束'
      }

    }

  },
  created() {
    this.wyqyId = sessionStorage.getItem('wyqy')
  },
  mounted() {
    if (!this.active) {
      this.getList()
    }
  },
  methods: {
    /**
     * 列表
     */
    getList() {
      let params = {
        openId: sessionStorage.getItem('openId'),
        tplx: this.active,
        wyqyId: Number(this.wyqyId),
      }
      this.vLoading = true
      api.voteList(params).then(res => {
        if (res.data.code == 200 && res.data.data) {
          this.currentData = res.data.data.splice(0, 3)
          this.vLoading = false
        } else {
          this.vLoading = false
        }

      }).catch(err => {
        this.$toast.fail({
          message: err,
        })
        this.vLoading = false
      })
    },
    /**
     * 筛选
     */
    fliterList() {
      let params = {
        openId: sessionStorage.getItem('openId'),
        tplx: this.params.tplx,
        tpzt: this.params.tpzt,
        wyqyId: sessionStorage.getItem('wyqy')
      }
      this.vLoading = true
      api.voteList(params).then(res => {
        if (res.data.code == 200) {
          this.currentData = res.data.data
          this.vLoading = false
        }

      }).catch(err => {
        this.$toast.fail({
          message: err,
        })
      })
    },

    /**
     * 投票详情
     */
    getInfo(item) {
      location.href = '/detail' + '?id=' + item.id + '&fwId=' + item.fwId

      this.$router.push({ path: '/detail', query: { id: item.id, fwId: item.fwId } })
    }
  },
  computed: {
    listLength() {
      return this.currentData.length
    }
  },
  watch: {
    active: {
      handler(val) {
        this.getList()
      },


      wyqyId: {
        handler(nval) {
          this.getList()
        },
        deep: true,
        immediate: true
      }
    }
  },
};
</script>

<style lang="less" scoped>
.full {
  height: 100%;
}

.van-count-down {
  display: inline-block;
  color: #ff6c19;
  width: 120px;
}

.voteBox {
  width: 100%;
  background: #fff;
  margin-top: 20px;
  border-radius: 3px;
  padding-bottom: 16px;

  &::after {
    content: "";
    display: block;
    height: 0;
    width: 0;
    clear: both;
  }

  .time {
    width: 244px;
    height: 30px;
    background: linear-gradient(96deg, #ffd8c1 0%, #fff6f1 100%);
    border-radius: 8px 0 24px 0px;
    font-size: 12px;
    color: #ff6c1a;
    padding-left: 12px;
    line-height: 30px;

    span {
      color: #ff6c1a;
      font-size: 15px;
      font-weight: bold;
      padding: 0 3px;
    }
  }

  .voteName {
    margin-top: 16px;
    padding: 0 16px;
    display: flex;

    img {
      display: block;
      width: 22px;
      height: 22px;
    }

    .name {
      flex: 1;
      margin-left: 3px;
      min-height: 21px;
      color: #222120;
      font-weight: bold;
    }
  }

  .voteBottom {
    padding: 0 16px;
    margin-top: 20px;

    button {
      padding: 0 17px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      background-color: #ff6c1a;
      color: #fff;
      border-radius: 30px;
      float: right;
      border: none;
      font-size: 13px;
    }

    .voteIn,
    .VoteType {
      display: inline-block;
      font-size: 13px;
      line-height: 30px;
      padding: 0 5px;
      border-radius: 3px;
    }

    .voteIn {
      background: #f7f7f7;
      color: #6b6a6a;
      border: 1px solid #e9e9e9;
      letter-spacing: 1px;

      img {
        // margin-top: 5px;
        margin-top: 6px;
        margin-right: 5px;
        float: left;
        width: 16px;
        height: 16px;
      }
    }

    .VoteType {
      color: #00c797;
      background: rgba(0, 199, 151, 0.05);
      border: 1px solid #00c797;
      margin-left: 5px;
    }
  }
}

.content {
  // height: 100%;

  .top {
    width: 180px;
    height: 200px;
    padding: 15px;
    position: relative;
    top: 10px;
    left: 50%;
    margin-left: -100px;
    text-align: center;
    // border: 1px dashed #4e4d4d;

    .image {
      width: 100%;
      // border: 1px dashed #4e4d4d;
    }

    .nadata {
      margin-top: 20px;
      font-size: 14px !important;
      font-weight: 400 !important;
      color: #4e4d4d !important;
    }
  }

  .footer {
    width: 100%;
    height: 33px;
    text-align: center;
    font-size: 14px !important;
    font-weight: 400 !important;
    color: #4e4d4d !important;
  }
}
</style>
